import { useCallback } from 'react';

import { ViableAccountsType, useUserConnectedAccounts } from '@givebacks/api/core';
import { Modal, ModalProps } from 'ui';

import { ChoosePaymentAccount } from '../../forms/ChoosePaymentAccount/ChoosePyamentAccount';

interface LinkedAccountsModalProps extends ModalProps {
  modalProps?: Partial<ModalProps>;
  onConnectAccount: (account: ViableAccountsType | 'hyperWallet') => void;
  onRemove?: (account: ViableAccountsType, accountId: string) => void;
  /** Called when a hyperwallet account doesn't exist on onCreateAccount  */
  onPendingAccount?: (account: ViableAccountsType) => void;
}

interface LinkedAccounts
  extends Pick<LinkedAccountsModalProps, 'onRemove' | 'onConnectAccount' | 'onPendingAccount'> {}

const LinkedAccounts = ({ onConnectAccount, onRemove, onPendingAccount }: LinkedAccounts) => {
  const { data: accountsStatus } = useUserConnectedAccounts();

  const handleNoHyperWalletAccount = useCallback(
    (account: ViableAccountsType) => {
      if (!accountsStatus?.hyperwallet_user) {
        onPendingAccount?.(account);
        return onConnectAccount('hyperWallet');
      }
      return onConnectAccount(account);
    },
    [accountsStatus?.hyperwallet_user, onConnectAccount, onPendingAccount]
  );

  return (
    <ChoosePaymentAccount onRemove={onRemove} openCreateAccount={handleNoHyperWalletAccount} />
  );
};

const LinkedAccountsModal = ({
  opened,
  onClose,
  modalProps,
  title,
  onRemove,
  onConnectAccount,
  onPendingAccount,
}: LinkedAccountsModalProps) => {
  return (
    <Modal opened={opened} onClose={onClose} title={title ?? 'Linked Accounts'} {...modalProps}>
      <LinkedAccounts
        onRemove={onRemove}
        onConnectAccount={onConnectAccount}
        onPendingAccount={onPendingAccount}
      />
    </Modal>
  );
};

export { LinkedAccountsModal };
